/**
 * Mixpanel Super Properties (https://developer.mixpanel.com/docs/javascript#super-properties)
 * get stored as a client-side cookie and attached to all subsequent events.
 *
 * naming convention: all lowercase, sentence case.
 *
 */
export const superProperties = Object.freeze({
  SUBSCRIPTION_STATUS: 'subscription status',
});

export const navigationProperties = Object.freeze({
  ROUTE: 'route',
});

export const interactionProperties = Object.freeze({
  BUTTON_NAME: 'name', // persistent value, not necessarily user-facing
  BUTTON_TEXT: 'text', // Text displayed to the user, can differ from BUTTON_NAME
});
